import { AttendanceStatusModule_isSeated, AttendanceStatus, AttendanceStatusModule_toInt, TagFormat_parse, AttendanceStatusModule_fromInt, AgeCategoryModule_fromInt, GenderModule_fromInt } from "../Shared/Types.js";
import { ta, t as t_1 } from "../Lang.js";
import { Guests_seated, Guests_showing, Guests_tagsHint, Guests_tagsColumn, Guests_familyColumn, Guests_statusColumn, Guests_ageColumn, Guests_genderColumn, Guests_nameColumn, Guests_none, Guests_plusNGuestsPlural, Guests_plusNGuests, Guests_adding, Guests_voiceInput, Guests_quickAddPlaceholder, Export_csv, Guests_import, Guests_add, Guests_cardView, Guests_tableView, Guests_networkMap, Guests_statusFilter, Guests_search, Guests_tagsFilter, Enum_Attendance_active, Enum_Attendance_notAttending, Enum_Attendance_attending, Enum_Attendance_invited, Enum_Attendance_notInvited, Enum_Age_child, Enum_Age_senior, Enum_Age_adult, Enum_Age_teen, Enum_Gender_male, Enum_Gender_nonbinary, Enum_Gender_female } from "../Shared/Tr.js";
import { map, defaultArg } from "../fable_modules/fable-library-js.4.28.0/Option.js";
import { length, singleton as singleton_1, isEmpty, empty as empty_1, cons, fold, collect, sortBy, ofArray, reverse, sortWith, filter, exists, tryFind } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { int32ToString, createObj, equals, comparePrimitives, uncurry2 } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { createElement } from "react";
import { defaultOf } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { Msg } from "../App/Messages.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { parseQuickAdd } from "../Shared/QuickAddParser.js";
import { empty, add, contains } from "../fable_modules/fable-library-js.4.28.0/Set.js";
import { collect as collect_1, map as map_1, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { tryParse } from "../fable_modules/fable-library-js.4.28.0/Int32.js";
import { FSharpRef } from "../fable_modules/fable-library-js.4.28.0/Types.js";
import { helpIcon } from "./Components.js";
import { isSupported } from "./SpeechInput.js";
import { view as view_1 } from "./TagVisualization.js";
import { GuestSortColumn } from "../Pages/Event/State.js";
import { View } from "./TagInput.js";

function genderLabel(g) {
    const matchValue = GenderModule_fromInt(g);
    switch (matchValue.tag) {
        case 1:
            return t_1(Enum_Gender_female);
        case 2:
            return t_1(Enum_Gender_nonbinary);
        case 3:
            return "-";
        default:
            return t_1(Enum_Gender_male);
    }
}

function genderIcon(g) {
    const matchValue = GenderModule_fromInt(g);
    switch (matchValue.tag) {
        case 1:
            return "♀";
        case 2:
            return "⚧";
        case 3:
            return "";
        default:
            return "♂";
    }
}

function ageCategoryLabel(a) {
    const matchValue = AgeCategoryModule_fromInt(a);
    switch (matchValue.tag) {
        case 1:
            return t_1(Enum_Age_teen);
        case 2:
            return t_1(Enum_Age_adult);
        case 3:
            return t_1(Enum_Age_senior);
        default:
            return t_1(Enum_Age_child);
    }
}

function attendanceStatusLabel(s) {
    const matchValue = AttendanceStatusModule_fromInt(s);
    switch (matchValue.tag) {
        case 1:
            return t_1(Enum_Attendance_notInvited);
        case 2:
            return t_1(Enum_Attendance_invited);
        case 3:
            return t_1(Enum_Attendance_attending);
        case 4:
            return t_1(Enum_Attendance_notAttending);
        default:
            return t_1(Enum_Attendance_active);
    }
}

function attendanceStatusClass(s) {
    const matchValue = AttendanceStatusModule_fromInt(s);
    switch (matchValue.tag) {
        case 1:
            return "badge-status badge-status-not-invited";
        case 2:
            return "badge-status badge-status-invited";
        case 3:
            return "badge-status badge-status-attending";
        case 4:
            return "badge-status badge-status-not-attending";
        default:
            return "badge-status badge-status-active";
    }
}

function familyName(guest, families) {
    return defaultArg(map((tupledArg_1) => tupledArg_1[0].Name, tryFind((tupledArg) => exists((m) => (m.GuestId === guest.Id), tupledArg[1]), families)), "-");
}

function filterGuests(search, guests) {
    if (search.trim() === "") {
        return guests;
    }
    else {
        const s = search.trim().toLowerCase();
        return filter((g) => {
            if (((g.FirstName.toLowerCase().indexOf(s) >= 0) ? true : (g.LastName.toLowerCase().indexOf(s) >= 0)) ? true : ((`${g.FirstName} ${g.LastName}`).toLowerCase().indexOf(s) >= 0)) {
                return true;
            }
            else {
                return defaultArg(g.Tags, "").toLowerCase().indexOf(s) >= 0;
            }
        }, guests);
    }
}

function sortGuests(col, dir, families, guests) {
    const sorted = sortWith(uncurry2((col.tag === 1) ? ((a_1) => ((b_1) => comparePrimitives(a_1.Gender, b_1.Gender))) : ((col.tag === 2) ? ((a_2) => ((b_2) => comparePrimitives(a_2.AgeCategory, b_2.AgeCategory))) : ((col.tag === 3) ? ((a_3) => ((b_3) => comparePrimitives(a_3.AttendanceStatus, b_3.AttendanceStatus))) : ((col.tag === 4) ? ((a_4) => ((b_4) => comparePrimitives(familyName(a_4, families), familyName(b_4, families)))) : ((col.tag === 5) ? ((a_5) => ((b_5) => comparePrimitives(defaultArg(a_5.Tags, ""), defaultArg(b_5.Tags, "")))) : ((a) => ((b) => comparePrimitives(`${a.LastName} ${a.FirstName}`, `${b.LastName} ${b.FirstName}`)))))))), guests);
    if (dir.tag === 1) {
        return reverse(sorted);
    }
    else {
        return sorted;
    }
}

function sortIndicator(col, currentCol, dir) {
    if (equals(col, currentCol)) {
        if (dir.tag === 1) {
            return createElement("span", {
                children: " v",
            });
        }
        else {
            return createElement("span", {
                children: " ^",
            });
        }
    }
    else {
        return defaultOf();
    }
}

function headerCell(label, col, currentCol, dir, dispatch) {
    let elems;
    return createElement("th", createObj(ofArray([["className", "sortable-header"], ["onClick", (_arg) => {
        dispatch(new Msg(75, [col]));
    }], (elems = [createElement("span", {
        children: label,
    }), sortIndicator(col, currentCol, dir)], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function currentLang() {
    const raw = localStorage.getItem('lang') || navigator.language?.slice(0,2) || 'en';
    if (raw.length >= 2) {
        return raw.slice(0, 1 + 1);
    }
    else {
        return "en";
    }
}

function parseQuickAddPreview(input) {
    return parseQuickAdd(currentLang(), input);
}

function collectAllTags(guests) {
    let list_1;
    return sortBy((t) => t.toLowerCase(), reverse(((list_1 = collect((g) => TagFormat_parse(g.Tags), guests), fold((tupledArg, tag) => {
        const seen = tupledArg[0];
        const acc = tupledArg[1];
        const key = tag.toLowerCase();
        if (contains(key, seen)) {
            return [seen, acc];
        }
        else {
            return [add(key, seen), cons(tag, acc)];
        }
    }, [empty({
        Compare: comparePrimitives,
    }), empty_1()], list_1)))[1]), {
        Compare: comparePrimitives,
    });
}

function renderGuestCard(guest, families, isSelected, dispatch) {
    let elems_5;
    const icon = genderIcon(guest.Gender);
    const fam = familyName(guest, families);
    return createElement("div", createObj(ofArray([["className", isSelected ? "guest-card guest-card-selected" : "guest-card"], ["onClick", (_arg) => {
        dispatch(new Msg(49, [guest.Id]));
    }], (elems_5 = toList(delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["className", "guest-card-header"], (elems = toList(delay(() => append(singleton(createElement("span", {
            className: "guest-card-name",
            children: `${guest.FirstName} ${guest.LastName}`,
        })), delay(() => ((icon !== "") ? singleton(createElement("span", {
            className: "guest-card-gender",
            children: icon,
        })) : singleton(defaultOf())))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(createElement("div", createObj(ofArray([["className", "guest-card-meta"], (elems_1 = toList(delay(() => append(singleton(createElement("span", {
                children: ageCategoryLabel(guest.AgeCategory),
            })), delay(() => append((fam !== "-") ? singleton(createElement("span", {
                children: fam,
            })) : singleton(defaultOf()), delay(() => singleton(createElement("span", {
                className: attendanceStatusClass(guest.AttendanceStatus),
                children: attendanceStatusLabel(guest.AttendanceStatus),
            })))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let matchValue, notes, notes_1;
                return append((matchValue = guest.DietaryNotes, (matchValue == null) ? singleton(defaultOf()) : (((notes = matchValue, notes.trim() !== "")) ? ((notes_1 = matchValue, singleton(createElement("div", {
                    className: "guest-card-dietary",
                    title: notes_1,
                    children: "🍽",
                })))) : singleton(defaultOf()))), delay(() => {
                    let elems_4;
                    const parsedTags = TagFormat_parse(guest.Tags);
                    return !isEmpty(parsedTags) ? singleton(createElement("div", createObj(ofArray([["className", "tag-list"], (elems_4 = toList(delay(() => map_1((t) => {
                        let elems_3, elements;
                        return createElement("span", createObj(ofArray([["className", "badge badge-clickable"], ["title", t_1(Guests_tagsFilter)], ["onClick", (e) => {
                            e.stopPropagation();
                            dispatch(new Msg(74, [t]));
                        }], (elems_3 = [t, createElement("svg", createObj(ofArray([["className", "icon-funnel"], ["viewBox", (((((0 + " ") + 0) + " ") + 16) + " ") + 16], (elements = singleton_1(createElement("path", {
                            d: "M1.5 1.5h13l-5 6v5l-3 2v-7z",
                            fill: "currentColor",
                        })), ["children", reactApi.Children.toArray(Array.from(elements))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
                    }, parsedTags))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : singleton(defaultOf());
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

export function view(state, dispatch) {
    let matchValue, s, elems_17;
    const allGuests = state.Guests;
    const sorted = sortGuests(state.GuestSortColumn, state.GuestSortDirection, state.Families, filterGuests(state.GuestSearch, (matchValue = state.GuestStatusFilter, (matchValue == null) ? allGuests : ((s = (matchValue | 0), filter((g) => (g.AttendanceStatus === s), allGuests))))));
    const allTags = collectAllTags(allGuests);
    const isEditing = (guestId, field) => {
        const matchValue_1 = state.InlineEditCell;
        if (matchValue_1 == null) {
            return false;
        }
        else if (matchValue_1[0] === guestId) {
            return matchValue_1[1] === field;
        }
        else {
            return false;
        }
    };
    return createElement("div", createObj(ofArray([["className", "guest-list-container"], (elems_17 = toList(delay(() => {
        let elems_4, elems_1, matchValue_2, elems_2, elems_3;
        return append(singleton(createElement("div", createObj(ofArray([["className", "guest-toolbar"], (elems_4 = [createElement("div", createObj(ofArray([["className", "guest-search search-input-wrapper"], (elems_1 = toList(delay(() => {
            let elements;
            return append(singleton(createElement("svg", createObj(ofArray([["className", "search-icon-funnel"], ["viewBox", (((((0 + " ") + 0) + " ") + 16) + " ") + 16], (elements = singleton_1(createElement("path", {
                d: "M1.5 1.5h13l-5 6v5l-3 2v-7z",
                fill: "currentColor",
            })), ["children", reactApi.Children.toArray(Array.from(elements))])])))), delay(() => append(singleton(createElement("input", {
                className: "form-input search-input-with-icon",
                type: "text",
                placeholder: t_1(Guests_search),
                value: state.GuestSearch,
                onChange: (ev) => {
                    dispatch(new Msg(74, [ev.target.value]));
                },
            })), delay(() => ((state.GuestSearch !== "") ? singleton(createElement("button", {
                className: "search-clear-btn",
                type: "button",
                "aria-label": "Clear",
                children: "×",
                onClick: (_arg) => {
                    dispatch(new Msg(74, [""]));
                },
            })) : singleton(defaultOf()))))));
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("select", createObj(ofArray([["className", "form-input form-input-sm guest-status-filter"], ["value", (matchValue_2 = state.GuestStatusFilter, (matchValue_2 == null) ? "" : int32ToString(matchValue_2))], ["onChange", (ev_1) => {
            const v_1 = ev_1.target.value;
            if (v_1 === "") {
                dispatch(new Msg(76, [undefined]));
            }
            else {
                let matchValue_3;
                let outArg = 0;
                matchValue_3 = [tryParse(v_1, 511, false, 32, new FSharpRef(() => outArg, (v_2) => {
                    outArg = (v_2 | 0);
                })), outArg];
                if (matchValue_3[0]) {
                    dispatch(new Msg(76, [matchValue_3[1]]));
                }
            }
        }], (elems_2 = [createElement("option", {
            value: "",
            children: t_1(Guests_statusFilter),
        }), createElement("option", {
            value: int32ToString(AttendanceStatusModule_toInt(new AttendanceStatus(0, []))),
            children: t_1(Enum_Attendance_active),
        }), createElement("option", {
            value: int32ToString(AttendanceStatusModule_toInt(new AttendanceStatus(1, []))),
            children: t_1(Enum_Attendance_notInvited),
        }), createElement("option", {
            value: int32ToString(AttendanceStatusModule_toInt(new AttendanceStatus(2, []))),
            children: t_1(Enum_Attendance_invited),
        }), createElement("option", {
            value: int32ToString(AttendanceStatusModule_toInt(new AttendanceStatus(3, []))),
            children: t_1(Enum_Attendance_attending),
        }), createElement("option", {
            value: int32ToString(AttendanceStatusModule_toInt(new AttendanceStatus(4, []))),
            children: t_1(Enum_Attendance_notAttending),
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["className", "flex gap-sm"], (elems_3 = toList(delay(() => {
            let matchValue_4, matchValue_5;
            return append(singleton(createElement("button", {
                className: "btn btn-sm guest-view-toggle",
                title: (matchValue_4 = state.GuestViewMode, (matchValue_4.tag === 1) ? t_1(Guests_networkMap) : ((matchValue_4.tag === 2) ? t_1(Guests_tableView) : t_1(Guests_cardView))),
                onClick: (_arg_1) => {
                    dispatch(new Msg(77, []));
                },
                children: (matchValue_5 = state.GuestViewMode, (matchValue_5.tag === 1) ? "⚬" : ((matchValue_5.tag === 2) ? "☰" : "▦")),
            })), delay(() => append(singleton(createElement("button", {
                className: "btn btn-primary",
                children: t_1(Guests_add),
                onClick: (_arg_2) => {
                    dispatch(new Msg(50, []));
                },
            })), delay(() => append(singleton(createElement("button", {
                className: "btn btn-secondary",
                children: t_1(Guests_import),
                onClick: (_arg_3) => {
                    dispatch(new Msg(96, []));
                },
            })), delay(() => append(!isEmpty(allGuests) ? singleton(createElement("button", {
                className: "btn btn-secondary",
                title: t_1(Export_csv),
                children: t_1(Export_csv),
                onClick: (_arg_4) => {
                    dispatch(new Msg(95, []));
                },
            })) : singleton(defaultOf()), delay(() => singleton(helpIcon(() => {
                dispatch(new Msg(268, ["02", undefined]));
            }))))))))));
        })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
            let elems_7;
            return append(singleton(createElement("div", createObj(ofArray([["className", "quick-add-bar"], (elems_7 = toList(delay(() => {
                let elems_5;
                return append(singleton(createElement("div", createObj(ofArray([["className", "quick-add-input-row"], (elems_5 = toList(delay(() => append(singleton(createElement("input", {
                    className: "form-input quick-add-input",
                    type: "text",
                    placeholder: t_1(Guests_quickAddPlaceholder),
                    value: state.QuickAddInput,
                    autoComplete: "off",
                    onChange: (ev_2) => {
                        dispatch(new Msg(83, [ev_2.target.value]));
                    },
                    onKeyDown: (e) => {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            dispatch(new Msg(84, []));
                        }
                    },
                })), delay(() => append(isSupported() ? singleton(createElement("button", {
                    className: state.IsListening ? "btn btn-sm quick-add-mic listening" : "btn btn-sm quick-add-mic",
                    title: t_1(Guests_voiceInput),
                    onClick: (_arg_5) => {
                        if (state.IsListening) {
                            dispatch(new Msg(90, []));
                        }
                        else {
                            dispatch(new Msg(89, []));
                        }
                    },
                    children: "🎤",
                })) : singleton(defaultOf()), delay(() => {
                    const matchValue_6 = state.QuickAddFlash;
                    return (matchValue_6 == null) ? singleton(defaultOf()) : singleton(createElement("span", {
                        className: "quick-add-flash",
                        children: `Added ${matchValue_6}`,
                    }));
                })))))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                    let elems_6;
                    const matchValue_7 = parseQuickAddPreview(state.QuickAddInput);
                    if (matchValue_7 == null) {
                        return singleton(defaultOf());
                    }
                    else {
                        const parsed = matchValue_7;
                        let displayName;
                        const title = (parsed.Title !== "") ? (`${parsed.Title} `) : "";
                        displayName = (`${title}${parsed.FirstName} ${parsed.LastName}`).trim();
                        let genderSymbol;
                        const matchValue_8 = parsed.Gender;
                        genderSymbol = ((matchValue_8.tag === 1) ? " ♀" : ((matchValue_8.tag === 2) ? " ⚧" : ((matchValue_8.tag === 3) ? "" : " ♂")));
                        let ageLabel;
                        const matchValue_9 = parsed.AgeCategory;
                        ageLabel = ((matchValue_9.tag === 1) ? " (Teen)" : ((matchValue_9.tag === 3) ? " (Senior)" : ((matchValue_9.tag === 2) ? "" : " (Child)")));
                        return singleton(createElement("div", createObj(ofArray([["className", "quick-add-preview"], (elems_6 = toList(delay(() => append(singleton(createElement("span", {
                            className: "quick-add-preview-label",
                            children: t_1(Guests_adding),
                        })), delay(() => append(singleton(createElement("span", {
                            className: "quick-add-preview-name",
                            children: `${displayName}${genderSymbol}${ageLabel}`,
                        })), delay(() => {
                            let tupledArg, tupledArg_1;
                            return append((parsed.PlusN > 0) ? singleton(createElement("span", {
                                className: "badge",
                                children: (parsed.PlusN === 1) ? ((tupledArg = Guests_plusNGuests(int32ToString(parsed.PlusN)), ta(tupledArg[0], tupledArg[1]))) : ((tupledArg_1 = Guests_plusNGuestsPlural(int32ToString(parsed.PlusN)), ta(tupledArg_1[0], tupledArg_1[1]))),
                            })) : singleton(defaultOf()), delay(() => map_1((tag) => createElement("span", {
                                className: "badge",
                                children: tag,
                            }), parsed.Tags)));
                        })))))), ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
                    }
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => {
                let elems_8, matchValue_10, elems_16, elems_15, children_2, children, children_6;
                return append(isEmpty(allGuests) ? singleton(createElement("div", createObj(ofArray([["className", "card"], (elems_8 = [createElement("p", {
                    className: "text-muted",
                    children: t_1(Guests_none),
                })], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))) : ((matchValue_10 = state.GuestViewMode, (matchValue_10.tag === 1) ? singleton(createElement("div", createObj(ofArray([["className", "guest-card-grid"], (elems_16 = toList(delay(() => collect_1((guest_1) => {
                    let matchValue_12;
                    return singleton(renderGuestCard(guest_1, state.Families, (matchValue_12 = state.SelectedGuestId, (matchValue_12 == null) ? false : (matchValue_12 === guest_1.Id)), dispatch));
                }, sorted))), ["children", reactApi.Children.toArray(Array.from(elems_16))])])))) : ((matchValue_10.tag === 2) ? singleton(view_1(state, dispatch)) : singleton(createElement("table", createObj(ofArray([["className", "data-table"], (elems_15 = [(children_2 = singleton_1((children = ofArray([headerCell(t_1(Guests_nameColumn), new GuestSortColumn(0, []), state.GuestSortColumn, state.GuestSortDirection, dispatch), headerCell(t_1(Guests_genderColumn), new GuestSortColumn(1, []), state.GuestSortColumn, state.GuestSortDirection, dispatch), headerCell(t_1(Guests_ageColumn), new GuestSortColumn(2, []), state.GuestSortColumn, state.GuestSortDirection, dispatch), headerCell(t_1(Guests_statusColumn), new GuestSortColumn(3, []), state.GuestSortColumn, state.GuestSortDirection, dispatch), headerCell(t_1(Guests_familyColumn), new GuestSortColumn(4, []), state.GuestSortColumn, state.GuestSortDirection, dispatch), headerCell(t_1(Guests_tagsColumn), new GuestSortColumn(5, []), state.GuestSortColumn, state.GuestSortDirection, dispatch)]), createElement("tr", {
                    children: reactApi.Children.toArray(Array.from(children)),
                }))), createElement("thead", {
                    children: reactApi.Children.toArray(Array.from(children_2)),
                })), (children_6 = toList(delay(() => map_1((guest) => {
                    let matchValue_11, id_1, elems_14, children_4, elems_13;
                    return createElement("tr", createObj(ofArray([["className", (matchValue_11 = state.SelectedGuestId, (matchValue_11 != null) ? ((matchValue_11 === guest.Id) ? ((id_1 = matchValue_11, "guest-row selected")) : "guest-row") : "guest-row")], ["onClick", (_arg_6) => {
                        dispatch(new Msg(49, [guest.Id]));
                    }], (elems_14 = [createElement("td", {
                        children: `${guest.FirstName} ${guest.LastName}`,
                    }), createElement("td", {
                        children: genderLabel(guest.Gender),
                    }), createElement("td", {
                        children: ageCategoryLabel(guest.AgeCategory),
                    }), (children_4 = singleton_1(createElement("span", {
                        className: attendanceStatusClass(guest.AttendanceStatus),
                        children: attendanceStatusLabel(guest.AttendanceStatus),
                    })), createElement("td", {
                        children: reactApi.Children.toArray(Array.from(children_4)),
                    })), createElement("td", {
                        children: familyName(guest, state.Families),
                    }), createElement("td", createObj(ofArray([["className", "inline-edit-cell"], ["onDoubleClick", (e_1) => {
                        e_1.stopPropagation();
                        dispatch(new Msg(78, [guest.Id, "tags"]));
                    }], ["onClick", (e_2) => {
                        if (isEditing(guest.Id, "tags")) {
                            e_2.stopPropagation();
                        }
                    }], (elems_13 = toList(delay(() => {
                        let elems_9, elems_12;
                        if (isEditing(guest.Id, "tags")) {
                            return singleton(createElement("div", createObj(ofArray([["className", "inline-edit-active"], ["onKeyDown", (e_3) => {
                                if (e_3.key === "Escape") {
                                    e_3.preventDefault();
                                    e_3.stopPropagation();
                                    dispatch(new Msg(80, []));
                                }
                                else if ((e_3.key === "Enter") && e_3.ctrlKey) {
                                    e_3.preventDefault();
                                    e_3.stopPropagation();
                                    dispatch(new Msg(81, []));
                                }
                            }], ["onBlur", (e_4) => {
                                const container = e_4.currentTarget;
                                setTimeout(() => {
                                    if (!(container.contains(document.activeElement))) {
                                        dispatch(new Msg(81, []));
                                    }
                                }, 250);
                            }], (elems_9 = [createElement(View, {
                                tags: state.InlineEditValue,
                                allTags: allTags,
                                disabled: false,
                                onChange: (newTags) => {
                                    dispatch(new Msg(79, [newTags]));
                                },
                                placeholderText: t_1(Guests_tagsHint),
                            })], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))));
                        }
                        else {
                            const tableTags = TagFormat_parse(guest.Tags);
                            return !isEmpty(tableTags) ? singleton(createElement("div", createObj(ofArray([["className", "tag-list"], (elems_12 = toList(delay(() => map_1((t) => {
                                let elems_11, elements_1;
                                return createElement("span", createObj(ofArray([["className", "badge badge-clickable"], ["title", t_1(Guests_tagsFilter)], ["onClick", (e_5) => {
                                    e_5.stopPropagation();
                                    dispatch(new Msg(74, [t]));
                                }], (elems_11 = [t, createElement("svg", createObj(ofArray([["className", "icon-funnel"], ["viewBox", (((((0 + " ") + 0) + " ") + 16) + " ") + 16], (elements_1 = singleton_1(createElement("path", {
                                    d: "M1.5 1.5h13l-5 6v5l-3 2v-7z",
                                    fill: "currentColor",
                                })), ["children", reactApi.Children.toArray(Array.from(elements_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_11))])])));
                            }, tableTags))), ["children", reactApi.Children.toArray(Array.from(elems_12))])])))) : singleton(createElement("span", {
                                children: "-",
                            }));
                        }
                    })), ["children", reactApi.Children.toArray(Array.from(elems_13))])])))], ["children", reactApi.Children.toArray(Array.from(elems_14))])])));
                }, sorted))), createElement("tbody", {
                    children: reactApi.Children.toArray(Array.from(children_6)),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_15))])]))))))), delay(() => {
                    let tupledArg_2, tupledArg_3;
                    const seatedCount = length(filter((g_1) => AttendanceStatusModule_isSeated(AttendanceStatusModule_fromInt(g_1.AttendanceStatus)), allGuests)) | 0;
                    return singleton(createElement("div", {
                        className: "guest-footer text-sm text-muted mt-1",
                        children: (((tupledArg_2 = Guests_showing(int32ToString(length(sorted)), int32ToString(length(allGuests))), ta(tupledArg_2[0], tupledArg_2[1]))) + " • ") + ((tupledArg_3 = Guests_seated(int32ToString(seatedCount)), ta(tupledArg_3[0], tupledArg_3[1]))),
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_17))])])));
}

